import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import TopBar from '../../../components/TopBar';
import CustomerDetailsPageActionButtons from '../components/CustomerDetailsPageActionButtons';
import CustomerDetailsTabs from '../components/CustomerDetailsTabs';
import CustomerRiskComplianceSection from '../components/riskCompliance/CustomerRiskComplianceSection';
import CustomerAmlScreeningSection from '../components/amlScreening/CustomerAmlScreeningSection';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import CustomerForm from '../components/CustomerForm';
import { useGetCustomerHandler } from '../dataHandlers/getCustomerHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

export default function CustomerDetailsPage() {
  const { customers: c } = useTranslatedMessages();
  const page = c?.pages?.details ?? {};
  useDocumentTitle(page?.document_title ?? 'Customer Details');
  const { profile_id } = useParams();
  const { customer, isLoading } = useGetCustomerHandler(profile_id);

  if (isLoading || !customer) return <DocumentSkeletonForm />;

  const isBusinessCustomer = customer?.type === 'BUSINESS';

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      {customer && (
        <Box sx={{ pb: 2 }}>
          <TopBar
            title={page?.top_bar_title ?? 'Customer Details'}
            subTitle={customer?.profile_id}
            identifier={customer?.profile_id}
          >
            <CustomerDetailsPageActionButtons />
          </TopBar>
        </Box>
      )}

      <CustomerDetailsTabs customer={customer}>
        {{
          details: (
            <CustomerForm
              onSubmit={() => {}}
              apiErrors={{}}
              initialData={customer}
              readOnly={true}
              edit={false}
              onCancel={() => {}}
              customerType={customer?.type}
            />
          ),
          risk: (
            <CustomerRiskComplianceSection
              profileId={profile_id}
              isBusinessCustomer={isBusinessCustomer}
              customer={customer}
            />
          ),
          aml: (
            <CustomerAmlScreeningSection
              profileId={profile_id}
              isBusinessCustomer={isBusinessCustomer}
              customer={customer}
            />
          ),
        }}
      </CustomerDetailsTabs>
    </Stack>
  );
}
